import { Attributes, Misc, ModelBase, NeoModel, Rules, Validation } from '@singularsystems/neo-core';
import { IAuthorisable } from '../../IAuthorisable';
import AuthorisationValues from '../../ValueObjects/AuthorisationValues';

@NeoModel
export default class Rate extends ModelBase	implements IAuthorisable {
    static typeName = "Rate";

    public rateId: number = 0;

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public rateDate: Date | null = null;

    @Attributes.Float(2)
    public taxRate: number = 0.00;

    @Attributes.Float(6)
    public basel3Retail: number = 0;

    @Attributes.Float(6)
    public basel3NonRetail: number = 0;

    @Attributes.Float(6)
    public liquidityCost: number = 0;

    @Attributes.Float(2)
    public trustThreshold: number = 0.00;

    @Attributes.Float(2)
    public companyThreshold: number = 0.00;

    @Attributes.Float(6)
    public defaultCommissionRate: number = 0.00;

    @Attributes.Float(2)
    @Attributes.Display("DWT Rate")
    public dwtRate: number = 0.00;
    
    @Attributes.ChildObject(AuthorisationValues, true)
    public authorisation: AuthorisationValues = new AuthorisationValues();

    public isPendingDelete: boolean = false;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
        rules.failWhen(c => !(c.taxRate >= 0 && c.taxRate <= 1), "Tax Rate must be between 0% and 100%");
        rules.failWhen(c => !(c.dwtRate >= 0 && c.dwtRate <= 1), "DWT Rate must be between 0% and 100%");
        rules.failWhen(c => !(c.defaultCommissionRate >= 0 && c.defaultCommissionRate <= 1), "Default commission rate must be between 0% and 100%");
        rules.failWhen(c => c.basel3Retail < 0, "Basel 3 Retail cannot be less than 0%");
        rules.failWhen(c => c.basel3NonRetail < 0, "Basel 3 Non Retail cannot be less than 0%");
        rules.failWhen(c => c.liquidityCost < 0, "Liquidity Cost cannot be less than 0%");
    }

    public toString(): string {
        if (this.isNew) {
            return "New rate";
        } else {
            return "Rate";
        }
    }
}